import { trpc } from "@blis/trpc/react";

import { Tab, TabPanel, Tabs, TabsList } from "@/components/ui/tabs";
import { cn } from "@/components/ui/utils";
import { Section } from "../components/Section";
import { TestSpecGroupTable } from "../components/tests/TestSpecGroupTable";
import { TestSpecsTable } from "../components/tests/TestSpecsTable";
import { useTabSearch } from "../hooks";

export function TestSpecsPage() {
  const { data } = trpc.admin.testSpec.list.useQuery();

  const tabs = useTabSearch("tests");

  const contentClassnames =
    "flex flex-col data-[state=active]:mt-4 data-[state=active]:flex-1 data-[state=inactive]:mt-0";

  return (
    <Tabs {...tabs} className="flex-1 flex flex-col" variant="segment">
      <Section.Title>
        <span className="inline-flex gap-4 items-center p-1">
          Test specs
          <div>
            <TabsList>
              <Tab id="tests">Test specs</Tab>
              <Tab id="groups">Groups</Tab>
            </TabsList>
          </div>
        </span>
      </Section.Title>

      <TabPanel id="tests" className={cn(contentClassnames, "flex-1")}>
        <TestSpecsTable tests={data} />
      </TabPanel>
      <TabPanel id="groups" className={cn(contentClassnames, "flex-1")}>
        <TestSpecGroupTable />
      </TabPanel>
    </Tabs>
  );
}
